import React from "react";
import { Link } from "react-router-dom";
type ClosingCTAProps = {
  title?: React.ReactNode;
  body?: string;
};
export function ClosingCTA({
  title = <>
      Let’s talk about your payroll <em className="text-oxblood" data-id="element-39" data-mp="2i8smbfsiumr4">and</em> HR technology.
    </>,
  body = "Whether something is broken, changing, or just not working well enough — it starts with a conversation."
}: ClosingCTAProps) {
  return <section aria-labelledby="closing-cta" className="border-t border-stone" data-id="element-40" data-mp="3axznynn9vsgl">
      <div className="shell py-24 md:py-32" data-id="element-41" data-mp="3fwklgfb53y1c">
        <div className="grid grid-cols-12 gap-x-6 gap-y-10" data-id="element-42" data-mp="3fv9j8jxceycc">
          <h2 id="closing-cta" className="col-span-12 font-display text-[clamp(2.5rem,5.4vw,5rem)] leading-[1.04] tracking-[-0.015em] text-navy lg:col-span-7" data-id="element-43" data-mp="317wtsk4f08go">
            {title}
          </h2>
          <div className="col-span-12 flex flex-col justify-end lg:col-span-4 lg:col-start-9" data-id="element-44" data-mp="3tu9b00g5jtcq">
            <p className="text-lg leading-relaxed text-charcoal/80" data-id="element-45" data-mp="2ipolnarp1ci">{body}</p>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-46" data-mp="w4two69mhmn1">
              <Link to="/contact" className="btn-primary" data-id="element-47" data-mp="r4pdg8hbydt4">
                Talk to Us
              </Link>
              <a href="mailto:hello@constantpayroll.com" className="btn-ghost" data-id="element-48" data-mp="15tllw6natsu9">
                hello@constantpayroll.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}